import React from "react";

export const MenuSeparator: React.FC = () => <div className="my-1 border-t border-border-light" />;
